import React, { useEffect, useState } from 'react';
import { t } from '../lib/i18n';

// Live: counts down to the end of the last day; teaser/upcoming: to the start (Dubai time).
const targetOf = (ev) => new Date(ev.mode === 'live' ? `${ev.end}T23:59:59+04:00` : `${ev.start}T00:00:00+04:00`).getTime();

export const LiveCountdown = ({ ev, testId = 'live-countdown' }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const id = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(id); }, []);
  const left = Math.max(0, targetOf(ev) - now);
  const parts = [
    [Math.floor(left / 86400000), t('jours'), 'd'],
    [Math.floor(left / 3600000) % 24, t('h'), 'h'],
    [Math.floor(left / 60000) % 60, t('min'), 'm'],
    [Math.floor(left / 1000) % 60, t('s'), 's'],
  ];
  return (
    <div className="flex items-stretch gap-1.5" dir="ltr" data-testid={testId}>
      {parts.map(([v, label, k]) => (
        <div key={k} className="min-w-[46px] text-center px-2 py-1.5 rounded-xl bg-black/35 backdrop-blur border border-white/10">
          <span className="block h-7 overflow-hidden text-2xl font-black text-white leading-7 tabular-nums">
            <span key={v} className="countdown-digit block" data-testid={`${testId}-${k}`}>{String(v).padStart(2, '0')}</span>
          </span>
          <span className="block text-[9px] uppercase tracking-wider text-white/70">{label}</span>
        </div>
      ))}
    </div>
  );
};

export default LiveCountdown;
